import React, { useCallback } from 'react';
import * as xstocksService from '../../../services/x-stocks.service';

const useTokenXstocks = () => {
  const findToken = useCallback(async (address: string, chainId: number) => {
    try {
      const response = await xstocksService.findTokenXstocks(address, chainId);
      const roleData = response.data;
      return roleData;
    } catch (error) {
      console.error('Failed to fetch token metadata:', error);
      throw error;
    }
  }, []);

  return {
    findToken,
  };
};

export default useTokenXstocks;
